<template lang="pug">

  section#inviteTeamContainer

    v-row

      v-col(cols="12" xs="3" sm="3").align-center.d-flex
        sos-button(@buttonClick="backToGroups" size="medium" buttonLabel="Voltar para os grupos" buttonIcon="mdi-arrow-left" buttonIconSize="16")

      v-col(cols="12" xs="6" sm="6").align-start.d-flex
        step-header(etapa="create")

      v-col(cols="12" xs="3" sm="3").align-center.d-flex

    section
      group-creation-form

</template>

<script>
  import StringMixin from '@/mixins/string.mixin'
  import StepHeader from '@/components/StepHeader'
  import GroupCreationForm from './GroupCreationForm'

  import SosButton from '@/components/SosButton'

  export default {
    name: 'CreateGroup',

    components: {
      StepHeader,
      GroupCreationForm,
      'sos-button': SosButton,
    },

    mixins: [
      StringMixin,
    ],

    data: () => ({
      etapa: 'create',
      // groupID: null,
    }),

    methods: {
      backToGroups () {
        this.$router.push('/admin/grupos')
      },
    },
  }
</script>

<style lang="sass" scoped>
  #inviteTeamContainer
    max-width: 1200px
    margin-left: auto
    margin-right: auto
    margin-top: 50px
    padding: 0
    // padding: 20px 30px
</style>
